<template>
  <div>
    <div class="btn-wrap view-mode" role="group">
      <button
        class="btn"
        :class="{ 'btn-active': txType.length === 0 }"
        type="button"
        @click="change('A')"
      >
        {{ $t('find.FOR_SALE_OR_LEASE_S') }}
      </button>
      <button
        class="btn"
        :class="{ 'btn-active': txType.includes('L') }"
        type="button"
        @click="change('L')"
      >
        {{ $t('find.FOR_LEASE_S') }}
      </button>
      <button
        class="btn "
        :class="{ 'btn-active': txType.includes('S') }"
        type="button"
        @click="change('S')"
      >
        {{ $t('find.FOR_SALE_S') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    txType: {
      type: Array,
      default: () => [],
    },
    hasBothType: {
      type: Boolean,
      default: () => true,
    },
  },
  methods: {
    change(value) {
      const txSet = new Set();
      if (value !== 'A') {
        txSet.add(value);
      }
      this.$emit('change', { txType: [...txSet] });
    },
  },
};
</script>

<style scoped>
.btn-wrap {
  display: flex;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}
.btn,
.btn:hover,
.btn:focus,
.btn:active {
  outline: none;
}

.btn {
  font-size: 16px;
  color: #252525;
  background: #ffffff;
  flex: 1;
  height: 38px;
}

.btn-active {
  background: #ffe100;
  font-weight: 700;
}
</style>
